// client/src/Components/ui/WhatsAppButton.js
import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = ({ message }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    // Trigger mount animation after a short delay
    const timer = setTimeout(() => {
      setIsMounted(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = () => {
    const phoneNumber = process.env.REACT_APP_WHATSAPP_NO;
    const formattedNumber = phoneNumber.replace(/\D/g, '');
    const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className={`
      fixed bottom-3 md:bottom-6  right-3 md:right-6 z-50
      transition-all duration-700 ease-out
      ${isMounted ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0'}
    `}>
      {/* Ripple effect background */}
      <div className={`
        absolute inset-0 rounded-full bg-green-300 opacity-20
        animate-ping
      `} />
      

      {/* Main button */}
      <button
        onClick={handleWhatsAppClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`
          relative flex items-center gap-2 
          bg-green-500 hover:bg-green-600 
          text-white px-4 py-2 rounded-full 
          shadow-lg transition-all duration-300
          hover:shadow-xl
          group
          ${isHovered ? 'pr-6 translate-x-1' : 'pr-4 translate-x-0'}
        `}
      >
        {/* Icon with enhanced hover animation */}
        <MessageCircle className={`
          w-5 h-5 transition-all duration-300
          ${isHovered ? 'rotate-12 scale-110' : 'rotate-0 scale-100'}
        `} />
        
        {/* Text with slide and scale animation */}
        {/* <span className={`
          transition-all duration-300 origin-left
          ${isHovered ? 'scale-105 translate-x-1' : 'scale-100 translate-x-0'}
        `}>
          Chat on WhatsApp
        </span> */}

        {/* Decorative dots that appear on hover */}
        <div className={`
          absolute -top-1 -right-1
          flex gap-1
          transition-all duration-300
          ${isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-2'}
        `}>
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className={`
                w-2 h-2 rounded-full bg-accent-hard
                animate-bounce
              `}
              style={{
                animationDelay: `${i * 100}ms`
              }}
            />
          ))}
        </div>
      </button>
    </div>
  );
};

export default WhatsAppButton;